import React, { useEffect, useState } from 'react';
import './CredentialsPage.css';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import {
  getLoading,
  createCredentialsAsync,
  setCredentailsLoading,
  deleteCredentialsAsync,
  updateCredentialsAsync,
  restoreCredentialsAsync,
} from '../../../features/redux/adminSlice';
import { useSelector } from 'react-redux';
import Confirm from '../../ui/Confirm/Confirm';
import SideSlider from '../../ui/SideSlider/SideSlider';
import { useForm } from 'react-forms-handler';
import validator from 'validator';
import { validateByFieldDynamic, validatePresenceOf } from '../../../utils';

const globals = {
  credentials: [],
  application_id: {},
  id: {},
};

function CredentialsPage({ credentials, applications }) {
  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const [openForm, setOpenForm] = useState(false);
  const [filteredCredential, setFilteredCredential] = useState(credentials);
  const { form, valid, id, value, user_name, password, application_id } =
    useForm({
      id: [''],
      user_name: [
        '',
        [
          [validatePresenceOf, 'Can not be empty'],
          [
            validateByFieldDynamic(
              () =>
                globals.credentials.filter(
                  (u) =>
                    u.application_id == globals.application_id.value &&
                    u.id != globals.id.value,
                ),
              'user_name',
            ),
            'User name exist for this application',
          ],
        ],
      ],
      password: ['', (str) => !validator.isEmpty(str)],
      application_id: [''],
    });

  const { serchField } = useForm({
    serchField: [''],
  });

  useEffect(() => {
    if (applications.length > 0) {
      application_id.value = applications[0].id;
    }
  }, [applications]);

  useEffect(() => {
    globals.credentials = credentials;
    globals.user_name = user_name;
    globals.application_id = application_id;
    globals.id = id;
  }, [credentials]);

  useEffect(() => {
    serchField.stateChange.subscribe((currentValue, prevValue) => {
      setFilteredCredential(
        credentials.filter((c) =>
          getSerchableText(c)
            .toLowerCase()
            .includes(currentValue.toLowerCase()),
        ),
      );
    });
  }, [serchField]);

  return (
    <div className='cred-dashboard-content'>
      <div className='dashboard-header'>
        <h1>Admin Dashboard Credential</h1>
        <input
          style={{ width: '20%' }}
          type='text'
          className='form-control'
          {...serchField.inputProps}
          placeholder='Search'
        />
        <button
          className='btn btn-primary'
          onClick={() => {
            setOpenForm(true);
          }}
        >
          Add Credential
        </button>
      </div>
      <table className='table'>
        <thead className='thead-light'>
          <tr>
            <th scope='col'>#</th>
            <th scope='col'>User Name</th>
            <th scope='col'>Password</th>
            <th scope='col'>Application</th>
            <th scope='col'>Active Sessions</th>
            <th scope='col'>Total Sessions</th>
            <th scope='col'>Created At</th>
            <th scope='col'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredCredential.map((cred, index) => {
            return (
              <tr
                key={`cred-${index}`}
                className={`${cred.deleted_at ? 'deleted' : ''}`}
              >
                <th scope='row'>{index + 1}</th>
                <td>{cred.user_name}</td>
                <td>**********</td>
                <td>{cred.application.name}</td>
                <td>{cred.active_sessions}</td>
                <td>{cred.total_sessions}</td>
                <td>{moment(cred.createdAt).format('MMM Do YY')}</td>
                {!cred.deleted_at && (
                  <td>
                    <i
                      className={`text-danger fa-solid fa-${isLoading.credentials != cred.id ? 'trash' : 'circle-notch fa-spin'}`}
                      onClick={() => {
                        Confirm.confirm(
                          'Are you sure you want to delete this seat? This action can not be undo',
                        )
                          .then(() => {
                            dispatch(setCredentailsLoading(cred.id));
                            dispatch(
                              deleteCredentialsAsync({ credentialId: cred.id }),
                            );
                          })
                          .catch((e) => {
                            console.log(e);
                          });
                      }}
                    ></i>
                    <i
                      style={{ marginLeft: '4px', cursor: 'pointer' }}
                      className={`text-primary fa-solid fa-edit`}
                      onClick={() => {
                        form.clearAllFields();
                        id.value = cred.id;
                        user_name.value = cred.user_name;
                        password.value = cred.password;
                        application_id.value = cred.application_id;
                        setOpenForm(true);
                      }}
                    ></i>
                  </td>
                )}
                {cred.deleted_at && (
                  <td>
                    <i
                      style={{ cursor: 'pointer' }}
                      className={`text-success fa-solid fa-${isLoading.credentials != cred.id ? 'trash-restore' : 'circle-notch fa-spin'}`}
                      onClick={() => {
                        Confirm.confirm(
                          'Are you sure you want to restore this seat?',
                        )
                          .then(() => {
                            dispatch(setCredentailsLoading(cred.id));
                            dispatch(restoreCredentialsAsync(cred));
                          })
                          .catch((e) => {
                            console.log(e);
                          });
                      }}
                    ></i>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <SideSlider open={openForm}>
        <i
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
          }}
          className={`text-primary fa-solid fa-rectangle-xmark`}
          onClick={() => {
            setOpenForm(false);
            form.clearAllFields();
          }}
        ></i>
        <form style={{ textAlign: 'left' }}>
          <div className='form-group'>
            <label>User Name</label>
            <input
              type='text'
              {...user_name.inputProps}
              className='form-control'
              id='exampleInputPassword1'
              placeholder='Enter username'
            />
            {user_name.touched && user_name.errors && (
              <small id='emailHelp' className='form-text text-danger '>
                {user_name.errors}
              </small>
            )}
          </div>
          <div className='form-group'>
            <label>Password</label>
            <input
              type='text'
              {...password.inputProps}
              className='form-control'
              id='exampleInputEmail1'
              aria-describedby='emailHelp'
              placeholder='Enter Password'
            />
            {password.touched && !password.valid && (
              <small id='emailHelp' className='form-text text-danger '>
                Can not be empty
              </small>
            )}
          </div>
          <div className='form-group'>
            <label>Application</label>
            <select className='form-control' {...application_id.inputProps}>
              {applications.map((app, index) => {
                return (
                  <option key={`role-${index}`} value={app.id}>
                    {app.name}
                  </option>
                );
              })}
            </select>
          </div>

          <button
            disabled={!valid || isLoading.credentials}
            type='submit'
            className='btn btn-primary'
            onClick={(e) => {
              if (!id.value) {
                dispatch(createCredentialsAsync(value));
              } else {
                dispatch(updateCredentialsAsync(value));
              }
              form.clearAllFields();
              setOpenForm(false);
              e.preventDefault();
            }}
          >
            Submit
          </button>
        </form>
      </SideSlider>
    </div>
  );
}

export default CredentialsPage;

function getSerchableText(cred) {
  return `${cred.user_name}${cred.application.name}${cred.active_sessions}${cred.total_sessoins}${moment(cred.createdAt).format('MMM Do YY')}`;
}
